import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import { EntityProps } from 'client/types'
import React, { memo } from 'react'
import { CommonEditorButtonEntityOrSubEntity } from 'src/editor/shared/components/button/common-editor-button-entity-or-sub-entity'
import { ButtonEntityInterface } from 'src/shared/entities/button/button.schema'

const ButtonNew = ({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
}: EntityProps<ButtonEntityInterface>) => {
  return (
    <BaseEntityNew
      entity={entity}
      flex
      flexColumn
      isMoveUpAllowed={isMoveUpAllowed}
      isMoveDownAllowed={isMoveDownAllowed}
    >
      <CommonEditorButtonEntityOrSubEntity entityOrSubEntity={entity} />
    </BaseEntityNew>
  )
}

export default memo(ButtonNew)
